/**
 * @module ol/ImageState
 */

/**
 * @enum {number}
 */
export default {
  IDLE: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3
};

//# sourceMappingURL=ImageState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ol/ImageState.js
// module id = 49
// module chunks = 0